module.exports = __webpack_public_path__ + "img/l-hd.98bbbd4e.webp";